// extracted by mini-css-extract-plugin
export var buttonContent = "_3n-0";
export var centered = "_3n-1";
export var centeredFlex = "_3n-2";
export var errorText = "_3n-3";
export var icon = "_3n-4";
export var iconButtonContent = "_3n-5";
export var monospace = "_3n-6";
export var padded = "_3n-7";